// [도메인 헤더 2026-07-26] 전역 fetch 래퍼
//
// 문제: 씨네체인(crm_unchain)과 영화거래소(crm_movie) 두 CRM이 같은 백엔드·같은 쿠키를 쓴다.
//   한 브라우저에서 두 창을 동시에 로그인하면 세션쿠키(req.session.domain)가 마지막 로그인 도메인으로 덮여
//   두 창의 조회/저장이 서로 섞인다(대행원가 500 등).
//
// 해결: 각 창은 자기 도메인을 sessionStorage("user").domain 에 독립 보관한다(창마다 다름).
//   이 래퍼가 same-origin 요청마다 그 값을 X-Domain 헤더로 실어 보내면, 백엔드 미들웨어가
//   요청 한정으로 도메인을 결정한다 → 두 창을 동시에 써도 안 섞인다.
//
// 안전장치:
//   - same-origin(상대경로 또는 현재 origin) 요청에만 헤더 부착. 외부 URL이면 원본 그대로(유출 0).
//   - 이미 X-Domain 헤더가 있으면 존중(중복 부착 안 함).
//   - domain 값이 없거나 허용목록 밖이면 헤더 미부착(기존 세션 폴백 = 하위호환).
//   - 백엔드도 화이트리스트로 재검증하므로 임의값이 흘러도 무해.

const ALLOWED = ['crm_unchain', 'crm_movie'];

function currentDomain() {
  try {
    const raw = sessionStorage.getItem('user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return (u && ALLOWED.includes(u.domain)) ? u.domain : null;
  } catch (e) {
    return null;
  }
}

// 요청 URL이 same-origin(우리 백엔드)인지 판정. 상대경로는 항상 same-origin.
function isSameOrigin(url) {
  try {
    if (typeof url !== 'string') url = String(url);
    // 프로토콜 상대(//host) 포함, 절대 URL만 origin 비교. 그 외(/, request/...)는 same-origin.
    if (/^([a-z][a-z0-9+.-]*:)?\/\//i.test(url)) {
      return new URL(url, window.location.href).origin === window.location.origin;
    }
    return true;
  } catch (e) {
    return true; // 파싱 실패 시 보수적으로 same-origin 취급(어차피 백엔드가 화이트리스트 재검증)
  }
}

// 헤더가 이미 X-Domain을 담고 있는지(대소문자·Headers/객체/배열 형태 모두 대응)
function hasDomainHeader(headers) {
  if (!headers) return false;
  try {
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return headers.has('X-Domain');
    }
    if (Array.isArray(headers)) {
      return headers.some(([k]) => String(k).toLowerCase() === 'x-domain');
    }
    return Object.keys(headers).some((k) => k.toLowerCase() === 'x-domain');
  } catch (e) {
    return false;
  }
}

export function installDomainFetch() {
  if (typeof window === 'undefined' || !window.fetch) return;
  if (window.__domainFetchInstalled) return; // 중복 설치 방지(HMR 등)
  window.__domainFetchInstalled = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    try {
      // 요청 URL 추출(Request 객체 또는 문자열)
      const url = (typeof Request !== 'undefined' && input instanceof Request) ? input.url : input;
      const domain = currentDomain();

      if (domain && isSameOrigin(url)) {
        init = init ? { ...init } : {};
        if (!hasDomainHeader(init.headers)) {
          // Request 객체에 이미 헤더가 들어있을 수 있으니 그것도 확인
          const reqHeaders = (typeof Request !== 'undefined' && input instanceof Request) ? input.headers : null;
          if (!hasDomainHeader(reqHeaders)) {
            const h = new Headers(init.headers || (reqHeaders || undefined));
            h.set('X-Domain', domain);
            init.headers = h;
          }
        }
      }
    } catch (e) {
      // 어떤 이유로든 래핑 실패 시 원본 요청 그대로 진행(요청을 절대 막지 않음)
    }
    return nativeFetch(input, init);
  };
}

export default installDomainFetch;
